import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import SaveIcon from "@mui/icons-material/Save";
import ApiUserManager from "../../../../../../core/api/api.userManager";
import SwalMessage from "../../../../_Components/SwalMessage";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { TextField } from "@mui/material";

function EditOrderPerson(props) {
  const [show, setShow] = useState(true);

  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
    control,
  } = useForm();
  const person = props.person;

  // ---------------------------------------------------------------------------------------------
  const handleClose = () => {
    setShow(!show);
    props.callBack();
  };

  useEffect(() => {
    (async () => {
      try {
        setValue("name", props.person.firstName);
        setValue("family", props.person.lastName);
      } catch (error) {
      }
    })();
    return () => { };
  }, []);
  // ---------------------------------------------------------------------------------------------------
  const onSubmit = async (data) => {
    const dataForUpdata = {
      basketId: props.basketId,
      id: person.id,
      firstName: data.name,
      lastName: data.family,
    };

    const response = await ApiUserManager.updateUserSite(dataForUpdata);
    SwalMessage({ title: response.message, iSsuccess: response.succeeded });

    handleClose();
  };

  return (
    <Modal show={show} size="md" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>ویرایش سفارش دهنده</Modal.Title>
      </Modal.Header>

      <Form id="form" onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Row>
            <Col xs="12" className="">
              <Controller
                name="name"
                control={control}
                rules={{ required: "true" }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label=" نام"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />

              <div className="my-1 py-1">
                {errors.name && <span className="text-danger my-2 py-2">این فیلد الزامی است.</span>}
              </div>
            </Col>
            <Col xs="12" className="">
              <Controller
                name="family"
                control={control}
                rules={{ required: "true" }}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    label=" نام خانوادگی"
                    margin="normal"
                    variant="outlined"
                    size="small"
                    value={value || ""}
                    onInput={onChange}
                  />
                )}
              />
              {/* <Form.Control
                size="sm"
                type="text"
                defaultValue={person.lastName}
                {...register("family", { required: true })}
              /> */}
              <div className="my-1 py-1">
                {errors.family && <span className="text-danger my-2 py-2">این فیلد الزامی است.</span>}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit" disabled={isSubmitting}>
            {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
            <SaveIcon />
            ذخیره
          </Button>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon />
            بستن
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default EditOrderPerson;
